import api from '../lib/api'
import assign from 'lodash.assign'

const name = 'knowledge-show'

export default {
  name,
  namespaced: true,
  state: {
    data: {}
  },
  getters: {},
  mutations: {
    set (state, data) {
      assign(state, data)
    }
  },
  actions: {
    async 'data:get' ({ commit }) {
      const data = await api.data.get()
      commit('set', { data })
    },
    async init ({ dispatch }) {
      console.log('init knowledge-show')
      // await dispatch('data:get')
    }
  }
}
